import { pageLoaders } from "./generated/page-loaders.js";
import { initializeScrollAnimations } from "./scroll-animations.js";
import { initializeAnalytics } from "./analytics.js";
import { initializeAccessibleVideos } from "./accessible-videos.js";

const status = document.querySelector("[data-js-status]");

if (status) {
  status.textContent = "JavaScript bundle loaded";
}

initializeScrollAnimations();
initializeAnalytics();
initializeAccessibleVideos();

const page = document.body.dataset.page;
const loadPage = pageLoaders[page];

if (loadPage) {
  loadPage()
    .then(({ default: initialize }) => {
      if (typeof initialize === "function") {
        initialize();
      }
    })
    .catch((error) => {
      console.error(`Unable to load JavaScript for the ${page} page.`, error);
    });
}

document.documentElement.dataset.js = "ready";
